import {Observable} from 'rxjs';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {CustomerProfileCard} from "../entity/customer-profile-cards";
import {SearchApiObservableService} from '../../../../../shared/filter/search-api-observable.service';
import {CardFilterModel} from '../../components/cards/card/card-filter-model.i';
import {get} from 'lodash';

@Injectable()
export class CustomerCardsService {

    constructor(private _http: Http,
                private _searchApiObservableService: SearchApiObservableService) {
    }

    getCustomerCards(id: number, filterModel: CardFilterModel): Observable<CustomerProfileCard[]> {
        return this._searchApiObservableService
            .searchRequestForUrl(`/api/backoffice/cards/all-for-profile/${id}`, filterModel)
            .map(response => get(response, 'cards', []))
    }

    changeCardState(cardId: number, statusId: number): Observable<CustomerProfileCard> {
        return this._http
            .patch(`/api/backoffice/cards/${cardId}/state?state=${statusId}`, {})
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/customer-cards.service.ts